// src/icons.ts

import L from 'leaflet';

// Importa tus imágenes reales, ajusta las rutas y nombres según tu estructura
import museumIconImg from './assets/museum.png';
import ruinsIconImg from './assets/ruins.png';
import monumentoIconImg from './assets/monumento.png';
import actividadIconImg from './assets/actividad.png';
import castleIconImg from './assets/castle.png';
import parkIconImg from './assets/park.png';
import restaurantIconImg from './assets/restaurant.png';
import viewpointIconImg from './assets/viewpoint.png';
import houseIconImg from './assets/house.png';

// Icono solo para el punto de inicio ("Inicio")
export const houseIcon = new L.Icon({
  iconUrl: houseIconImg,
  iconRetinaUrl: houseIconImg,
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [35, 41],
  iconAnchor: [10, 34],
  popupAnchor: [1, -30],
});

// Icono para Attraction/Monument
export const monumentIcon = new L.Icon({
  iconUrl: monumentoIconImg,
  iconRetinaUrl: monumentoIconImg,
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [35, 41],
  iconAnchor: [10, 34],
  popupAnchor: [1, -30],
});

// Icono para Museum
const museumIcon = new L.Icon({
  iconUrl: museumIconImg,
  iconRetinaUrl: museumIconImg,
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [35, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

// Icono para Ruins
const ruinsIcon = new L.Icon({
  iconUrl: ruinsIconImg,
  iconRetinaUrl: ruinsIconImg,
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [35, 41],
  iconAnchor: [10, 41],
  popupAnchor: [1, -34],
});

// Icono para Actividad
const actividadIcon = new L.Icon({
  iconUrl: actividadIconImg,
  iconRetinaUrl: actividadIconImg,
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [35, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

// Icono para Castle
const castleIcon = new L.Icon({
  iconUrl: castleIconImg,
  iconRetinaUrl: castleIconImg,
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [35, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

// Icono para Park
const parkIcon = new L.Icon({
  iconUrl: parkIconImg,
  iconRetinaUrl: parkIconImg,
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [35, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

// Icono para Restaurant, Bar, Cafe
const restaurantIcon = new L.Icon({
  iconUrl: restaurantIconImg,
  iconRetinaUrl: restaurantIconImg,
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [35, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

// Icono para Viewpoint
const viewpointIcon = new L.Icon({
  iconUrl: viewpointIconImg,
  iconRetinaUrl: viewpointIconImg,
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [35, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

// Si quieres usar un icono por defecto distinto, configúralo aquí
const defaultIcon = museumIcon; // Por ejemplo, usas el de Museum como fallback

/**
 * Función para devolver el icono según el tipo de lugar.
 * Ajusta los 'case' o 'if' según tus tipos reales.
 */
export function getIconForLugarType(tipo: string): L.Icon {
  switch (tipo) {
    // House (solo si se llama "Inicio", por ejemplo)
    case 'Inicio':
      return houseIcon;

    // Museum
    case 'Museum':
      return museumIcon;

    // Ruins
    case 'Ruins':
      return ruinsIcon;

    // Bar, Cafe => icono de restaurant
    case 'Bar':
    case 'Cafe':
    case 'Restaurant':
    case 'Pub':
      return restaurantIcon;

    // Attraction, Monument => icono monument
    case 'Attraction':
    case 'Monument':
      return monumentIcon;

    // Castle
    case 'Castle':
      return castleIcon;

    // Park
    case 'Park':
      return parkIcon;

    // Viewpoint
    case 'Viewpoint':
      return viewpointIcon;

    // Actividad al aire libre
    case 'Actividad al aire libre':
      return actividadIcon;

    // Si no coincide con nada => icono por defecto
    default:
      return defaultIcon;
  }
}
